export default "__VITE_ASSET__BAdsasg1__"